module.exports = __webpack_public_path__ + "2814dabc16ffed8c4b5cbedd1acf4331.png";